import {FunctionalComponent, h} from "preact";
import {useEffect} from "preact/hooks";

export interface ConfigItem {
  configKey: string;
  v: Record<string, never>;
}

const SetGlobalCfgItem: FunctionalComponent<{
  msgID: string;
  cfgItemData: ConfigItem;
  setGlobalCfgItem: (cfgItemData: ConfigItem) => void;
  tickCallback: () => void;
}> = ({
  msgID,
  setGlobalCfgItem,
  tickCallback,
  cfgItemData
}) => {

  useEffect(() => {
    // log.info(`typing for msgID ${msgID}`);
    /** advance queue */
    setGlobalCfgItem(cfgItemData);
    tickCallback();
  }, [msgID]);

  return null;
}

export default SetGlobalCfgItem;